import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { ThreeColumnListItem } from '../../ListItem/ThreeColumnListItem'
import { STYLES } from '../../../static/style'
import { Text } from '../../../components/Text'
import { showModal } from '../../../states/modals/actions'
import { ModalType } from '../../../states/modals/ModalType.constants'
import { AddIcon } from '../../../components/Icon/AddIcon'
import { PageRoutes } from '../../constants/PageRoutes'

const StyledAddSchoolListingItem = styled(ThreeColumnListItem)`
  display: flex;
  min-height: 3.75rem;
  background-color: ${STYLES.COLOR_OUTER_SPACE_GRAY};
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${STYLES.PRIMARY_COLOR};
    * {
      color: ${STYLES.COLOR_OUTER_SPACE_GRAY};
    }
  }
`

const StyledAddIcon = styled(AddIcon)`
  color: ${STYLES.PRIMARY_COLOR};
  font-size: ${STYLES.FONT_SIZE_XL};
  margin-right: 0.25rem;
`

const StyledText = styled(Text)`
  color: ${STYLES.PRIMARY_COLOR};
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

const AddSchoolListingItem = () => (
  <StyledAddSchoolListingItem to={PageRoutes.ADVERTISE_BASIC_ACTIVITY_PLAN}>
    <StyledAddIcon />
    <StyledText>Register your activity</StyledText>
  </StyledAddSchoolListingItem>
)

export { AddSchoolListingItem }
